import { render, staticRenderFns } from "./Kalkulator.vue?vue&type=template&id=0a3e1b94&"
import script from "./Kalkulator.vue?vue&type=script&lang=js&"
export * from "./Kalkulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports